// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  color: #f89624;
}

/*skrijem glede na velikost ekrana*/
@media(min-width: 1050px){

  .mobileHide {
    display: none;
    backface-visibility: hidden;
  }

}

@media(max-width: 1050px){

  .desktopHide {
    display: none;
  }

}



.dragDropContainer {
  border-style: dotted;
  border: 2px dashed black;
  border-radius: 10px;
  background-color: #FFF5E3;
}



/*drag and drop*/
.fileover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/uredi-task/dokumenti/dokumenti.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;EAEE;IACE,aAAa;IACb,2BAA2B;EAC7B;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;AAEF;;;;AAIA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;;;AAIA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,8CAA8C,EAAE;EACtD,MAAM,4CAA4C,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,4CAA4C,EAAE;EACpD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD","sourcesContent":["a {\n  color: #f89624;\n}\n\n/*skrijem glede na velikost ekrana*/\n@media(min-width: 1050px){\n\n  .mobileHide {\n    display: none;\n    backface-visibility: hidden;\n  }\n\n}\n\n@media(max-width: 1050px){\n\n  .desktopHide {\n    display: none;\n  }\n\n}\n\n\n\n.dragDropContainer {\n  border-style: dotted;\n  border: 2px dashed black;\n  border-radius: 10px;\n  background-color: #FFF5E3;\n}\n\n\n\n/*drag and drop*/\n.fileover {\n  animation: shake 0.5s;\n  animation-iteration-count: infinite;\n}\n\n@keyframes shake {\n  0% { transform: translate(1px, 1px) rotate(0deg); }\n  10% { transform: translate(-1px, -2px) rotate(-1deg); }\n  20% { transform: translate(-3px, 0px) rotate(1deg); }\n  30% { transform: translate(3px, 2px) rotate(0deg); }\n  40% { transform: translate(1px, -1px) rotate(1deg); }\n  50% { transform: translate(-1px, 2px) rotate(-1deg); }\n  60% { transform: translate(-3px, 1px) rotate(0deg); }\n  70% { transform: translate(3px, 1px) rotate(-1deg); }\n  80% { transform: translate(-1px, -1px) rotate(1deg); }\n  90% { transform: translate(1px, 2px) rotate(0deg); }\n  100% { transform: translate(1px, -2px) rotate(-1deg); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
